export default __webpack_public_path__ + "aa07fbe0a64eeae5994013964a8a3933.svg";